// =============================================================================
// FILE:
// frontend/src/pms/task_execution/services/taskMaterialRequestService.js
// =============================================================================

import axiosClient
from "../../../../api/axiosClient";


// =============================================================================
// CREATE REQUEST
// =============================================================================

export async function createMaterialRequest(

  payload = {}

) {

  const response =
    await axiosClient.post(

      
      "/api/pms/task-material-request/create",

      payload
    );

  return response.data;
}


// =============================================================================
// GET REQUEST DETAILS
// =============================================================================

export async function getMaterialRequestDetails(

  requestId

) {

  const response =
    await axiosClient.get(

      `/api/pms/task-material-request/${requestId}`
    );

  return response.data;
}


// =============================================================================
// GET TASK REQUESTS
// =============================================================================

// =============================================================================
// GET TASK REQUESTS
// =============================================================================

export async function getTaskMaterialRequests(

  taskId

) {

  const response =
    await axiosClient.get(

      "/api/pms/task-material-request/my-requests",

      {
        params: {
          task_id: taskId
        }
      }
    );

  return response.data;
}

// =============================================================================
// SUBMIT REQUEST
// =============================================================================

export async function submitMaterialRequest(

  requestId

) {

  const response =
    await axiosClient.post(

      `/api/pms/task-material-request/${requestId}/submit`
    );

  return response.data;
}


// =============================================================================
// APPROVE REQUEST LINE
// =============================================================================

export async function approveRequestLine(

  requestLineId,

  payload = {}

) {

  const response =
    await axiosClient.post(

      `/api/pms/task-material-request/line/${requestLineId}/approve`,

      payload
    );

  return response.data;
}


// =============================================================================
// REJECT REQUEST LINE
// =============================================================================

export async function rejectRequestLine(

  requestLineId,

  payload = {}

) {

  const response =
    await axiosClient.post(

      `/api/pms/task-material-request/line/${requestLineId}/reject`,

      payload
    );

  return response.data;
}


// =============================================================================
// ISSUE AGAINST REQUEST LINE
// =============================================================================

export async function issueAgainstRequestLine(

  requestLineId,

  payload = {}

) {

  const response =
    await axiosClient.post(

      `/api/pms/task-material-request/line/${requestLineId}/issue`,

      payload
    );

  return response.data;
}


// =============================================================================
// GET PENDING APPROVALS
// =============================================================================

export async function getPendingApprovals(

  filters = {}

) {

  const response =
    await axiosClient.get(

      "/api/pms/task-material-request/pending-approvals",

      {
        params: filters
      }
    );

  return response.data;
}


// =============================================================================
// GET ISSUE HISTORY
// =============================================================================

export async function getIssueHistory(

  taskId

) {

  const response =
    await axiosClient.get(

      `/api/pms/task-material-request/task/${taskId}/issues`
    );

  return response.data;
}